export default __webpack_public_path__ + "static/media/Vehicles.f6d7f086.webp";